import React, { useContext } from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { withStyles, Typography, Link, Box } from '@material-ui/core'
import { Checkbox, AuthContext } from 'elentari'
import {
  CustomDatePicker,
  CustomTextField
} from '../../../components/CustomDisabledFields'
import CustomFileViewer from '../../../components/CustomFileViewer'
import DropzoneField from '../../../components/DropzoneField'
import NumberFormatCustom from '../../../components/NumberFormatCustom'
import * as R from 'ramda'
import { SolicitacoesFonteLiberacaoHistorico, StatusEnum } from '../components'
import UsuarioAutocomplete from '../../Usuarios/UsuarioAutocomplete'
import StatusLabel from '../../../components/StatusLabel'
import { CustomAutocomplete } from '../../../components'
import { parseTelefone } from '../../../utils/Parse'
import ObservacaoField from '../../../components/ObservacaoField'
import CentroCustoAutocomplete from '../../CentrosCusto/CentroCustoAutocomplete'
import { Alert } from '@material-ui/lab'

const styles = theme => ({
  root: {
    padding: theme.spacing(6)
  },
  marginTop: {
    marginTop: theme.spacing(5)
  }
})

const Prioridade = {
  Baixa: 1,
  Normal: 2,
  Alta: 3,
  Urgente: 4
}

function InfoSolicitacaoForm({ classes, values, cannotUpdate }) {
  const { user } = useContext(AuthContext)
  const cpfMotorista = R.pathOr(undefined, ['motorista', 'cpf'], values)
  const grExternaFile = values.grExternaFile
  const contratoAgregado = values.contratoAgregado
  const canEdit = user.realm === 'admin' || user.realm === 'analista_2'

  const isRenovado = values?.renovado
  const fichaAssistente = values?.exclusivaAnalista2
  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Histórico
          </Typography>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
          >
            <Grid
              item
              xs={12}
              md={12}
              lg={isRenovado || fichaAssistente ? 8 : 12}
            >
              <SolicitacoesFonteLiberacaoHistorico
                cpfMotorista={cpfMotorista}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={4} component={Box} mt={5}>
              {isRenovado && (
                <Alert severity="info">
                  Renovação de Solicitação⠀
                  {values?.ultimaLiberadaId && (
                    <Link
                      href={`/solicitacoesAnalista/${values?.ultimaLiberadaId}`}
                      target="_blank"
                      color="inherit"
                      underline="always"
                      style={{ cursor: 'pointer' }}
                    >
                      Consultar Última
                    </Link>
                  )}
                </Alert>
              )}
              {fichaAssistente && (
                <Alert severity="info">Ficha exclusiva Assistente</Alert>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.marginTop} variant="h6" gutterBottom>
            Solicitação
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            {canEdit && !cannotUpdate ? (
              <>
                <Grid item xs={12} sm={6}>
                  <Field
                    fullWidth
                    disabled={!values.statusManual || cannotUpdate}
                    label="Status"
                    name="status"
                    component={CustomAutocomplete}
                    options={Object.values(StatusEnum)
                      .filter(
                        status =>
                          ![
                            StatusEnum.LIBERADAAUTOMATICAMENTE,
                            StatusEnum.LIBERADA,
                            StatusEnum.LIBERADACOMPENDENCIA,
                            StatusEnum.LIBERADAGESTOR,
                            StatusEnum.LIBERADAMONITORAMENTO
                          ].includes(status)
                      )
                      .map(status => ({
                        label: status,
                        value: status
                      }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <Field
                    component={Checkbox}
                    disabled={cannotUpdate}
                    label="Definir manualmente"
                    name="statusManual"
                    type="checkbox"
                  />
                </Grid>
              </>
            ) : (
              <Grid item xs={12} sm={6}>
                <Field
                  fullWidth
                  component={CustomTextField}
                  disabled
                  label="Status"
                  name="status"
                />
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            label="GR"
            disabled
            hideEmpty
            component={CustomAutocomplete}
            options={[
              { label: 'Terceiro', value: 'TERCEIRO' },
              { label: 'Agregado', value: 'AGREGADO' }
            ]}
            name="gr"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomFileViewer
            newTab
            label="Contrato Agregado"
            filePath={contratoAgregado}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            disabled
            component={Checkbox}
            label="DDR"
            name="ddr"
            type="checkbox"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            fullWidth
            component={CustomTextField}
            label="GR Externa"
            name="grExternaTexto"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            disabled={cannotUpdate}
            solicitacaoId={values.id}
            accept=".jpg,.jpeg,.png,.pdf"
            component={DropzoneField}
            label="Upload GR Externa"
            name="grExternaFile"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomFileViewer
            newTab
            label="GR Externa"
            filePath={grExternaFile}
            fileType="pdf"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.marginTop} variant="h6" gutterBottom>
            Responsável
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            fullWidth
            hideEmpty
            disabled={!canEdit || cannotUpdate}
            component={CustomAutocomplete}
            options={Object.keys(Prioridade).map(key => ({
              value: Prioridade[key],
              label: key
            }))}
            label="Prioridade"
            name="prioridade"
          />
        </Grid>
        {canEdit && (
          <Grid item xs={12} sm={3}>
            <Field
              disabled={cannotUpdate}
              component={Checkbox}
              label="Exclusiva"
              name="exclusiva"
              type="checkbox"
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <Grid container spacing={3}>
            {canEdit && values.responsavelManual ? (
              <>
                <Grid item xs={12} sm={6}>
                  <Field
                    fullWidth
                    component={UsuarioAutocomplete}
                    realm="analistaadmin"
                    label="Responsável"
                    name="responsavelId"
                  />
                </Grid>
              </>
            ) : (
              <Grid item xs={12} sm={6}>
                <Field
                  fullWidth
                  component={CustomTextField}
                  disabled
                  label="Responsável"
                  name="responsavel.usuario"
                />
              </Grid>
            )}
            {canEdit && (
              <Grid item xs={6} sm={3}>
                <Field
                  disabled={cannotUpdate}
                  component={Checkbox}
                  label="Definir manualmente"
                  name="responsavelManual"
                  type="checkbox"
                />
              </Grid>
            )}
          </Grid>
          <Grid item xs={12}>
            {[StatusEnum.ANALISE, StatusEnum.REANALISE].includes(
              values.status
            ) &&
              !values.responsavelId && (
                <Typography variant="caption" color="error">
                  Responsável obrigatório caso status {values.status}
                </Typography>
              )}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.marginTop} variant="h6" gutterBottom>
            Viagem
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            fullWidth
            component={CustomTextField}
            disabled
            label="Mercadoria"
            name="mercadoria.descricao"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            fullWidth
            component={CustomTextField}
            disabled
            label="Cliente"
            name="cliente"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field
            fullWidth
            component={CustomTextField}
            disabled
            label="Tempo"
            name="tempoViagem"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field
            fullWidth
            component={CustomTextField}
            InputProps={{
              inputComponent: NumberFormatCustom
            }}
            disabled
            label="Valor Carga"
            name="valorCarga"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <div style={{ display: 'flex' }}>
            <Field
              fullWidth
              component={CustomTextField}
              InputProps={{
                inputComponent: NumberFormatCustom
              }}
              disabled
              label="Limite Carga"
              name="motorista.limiteCarga"
            />
            {values.motorista ? (
              <StatusLabel
                state={
                  values.valorCarga > values.motorista.limiteCarga
                    ? 'error'
                    : 'success'
                }
                tooltipMessage="Valor da carga é maior que o limite do motorista"
              />
            ) : null}
          </div>
        </Grid>
        <Grid item xs={12} sm={12} lg={4}>
          <Field
            fullWidth
            component={CustomTextField}
            disabled
            label="País Origem"
            name="paisOrigem"
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={4}>
          <Field
            fullWidth
            component={CustomTextField}
            disabled
            label="Estado Origem"
            name="estadoOrigem"
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={4}>
          <Field
            fullWidth
            component={CustomTextField}
            disabled
            label="Cidade Origem"
            name="cidadeOrigem"
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={4}>
          <Field
            fullWidth
            component={CustomTextField}
            disabled
            label="País Destino"
            name="paisDestino"
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={4}>
          <Field
            fullWidth
            component={CustomTextField}
            disabled
            label="Estado Destino"
            name="estadoDestino"
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={4}>
          <Field
            fullWidth
            component={CustomTextField}
            disabled
            label="Cidade Destino"
            name="cidadeDestino"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.marginTop} variant="h6" gutterBottom>
            Embarcador
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field
            fullWidth
            component={CentroCustoAutocomplete}
            disabled
            label="Centro Custo"
            name="centroCustoId"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field
            fullWidth
            component={CustomTextField}
            disabled
            label="Nome"
            name="nomeEmbarcador"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field
            fullWidth
            disabled
            name="embarcador.telefone"
            label="Telefone"
            InputLabelProps={{ shrink: true }}
            format={parseTelefone}
            component={CustomTextField}
          />
        </Grid>
        {values.status === StatusEnum.LIBERADAGESTOR && (
          <>
            <Grid item xs={12}>
              <Typography
                className={classes.marginTop}
                variant="h6"
                gutterBottom
              >
                Observações Gestor
              </Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Field
                fullWidth
                component={CustomTextField}
                disabled
                label="Observação"
                name="observacaoLiberadaGestor"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Field
                fullWidth
                component={CustomDatePicker}
                disabled
                label="Data de Bloqueio"
                name="motorista.dataBloqueio"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomFileViewer
                newTab
                label="Anexo"
                filePath={values.anexoLiberadaGestor}
                fileType="pdf"
              />
            </Grid>
          </>
        )}
        {values.status === StatusEnum.PENDENTE && (
          <>
            <Grid item xs={12}>
              <Typography
                className={classes.marginTop}
                variant="h6"
                gutterBottom
              >
                Motivo Pendência
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                fullWidth
                component={CustomTextField}
                disabled
                label="Motivo"
                name="motivoPendencia"
              />
            </Grid>
          </>
        )}
        <ObservacaoField
          value={values.observacaoInformacoesGerais}
          title="Observações Informações gerais"
          placeholder="Escreva aqui observações sobre as informações gerais"
          name="novaObservacaoInformacoesGerais"
          disabled={cannotUpdate}
        />
      </Grid>
    </div>
  )
}

export default withStyles(styles)(InfoSolicitacaoForm)
